import { withStyles } from '@material-ui/core';

import BonusTransferPage from './component';
import styles from './styles';

export default withStyles(styles)(BonusTransferPage);
